import React from "react";
import Spinner from "./Spinner";

const NullSpinner = ({ checky, nullTrigger }) => {
	return <div>{checky > nullTrigger ? "" : <Spinner />}</div>;
};

export default NullSpinner;
